import request from "../utils/request";

export async function GetMoodProfileImages() {
    return request.get("MoodProfileImage/mood-profile-images",{
      params:{
        pageSize:999
      }
    })
  }
  export async function CreateMood(mood) {
    return request.post("MoodProfileImage/mood-profile-image", mood);
  }
  export async function UpdateMood(mood) {
    return request.put("MoodProfileImage/mood-profile-image", mood);
  }